import api from './axios';

export const fetchInvoiceByOrder = (orderId) =>
  api.get(`/invoices/order/${orderId}`).then((r) => r.data);

export const fetchInvoiceByAppointment = (appointmentId) =>
  api.get(`/invoices/appointment/${appointmentId}`).then((r) => r.data);

export const downloadInvoicePdf = async (invoiceId, invoiceNumber) => {
  const response = await api.get(`/invoices/${invoiceId}/pdf`, { responseType: 'blob' });
  const blob = new Blob([response.data], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${invoiceNumber || 'invoice'}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const openInvoicePdf = async (invoiceId) => {
  const response = await api.get(`/invoices/${invoiceId}/view`, { responseType: 'blob' });
  const blob = new Blob([response.data], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank', 'noopener,noreferrer');
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};
